import { connect } from "react-redux";
import SiteEngineerList from "./siteEngineerList";
import { bindActionCreators } from "redux";
import { getSiteEngineerList } from "services/redux/installation/siteEngineerList/action";

const mapStateToProps = (state) => ({
  siteEngineerList: state.siteEngineerListReducer.siteEngineerList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({
    getSiteEngineerList,
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SiteEngineerList);
